import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate } from "react-router-dom";
import { debounce } from "lodash";
import { Breadcrumb, Input, Table, Space, Popconfirm, Col, Row, Tooltip } from "antd";
import { getRequest, postRequest } from "../../axios";
import { ReactComponent as ArchiveRestore } from "../../image/ArchiveRestore.svg";
import ButtonField from "../../common/htmlComponents/ButtonField";
import SearchIcon from "../../image/SearchIcon.svg";
import {
  ErrorNotificationMsg,
  SuccessNotificationMsg,
} from "../../utils/Notifications";
import "antd/dist/antd.min.css";
import "../../styles/Main.scss";
import { authUserData } from "../../utils/Helper";
const { Search } = Input;

const ArchiveAssignSite = () => {
  const { t } = useTranslation();
  const CompanyId = authUserData()?.company ? authUserData()?.company : null;
  const [loading, setLoading] = useState(false);
  const [archiveVendorDocument, setArchiveVendorDocument] = useState([]);
  const [totalCount, settotalCount] = useState(0);
  const [selectedRow, setSelectedRow] = useState([]);
  const [reload, setReload] = useState(false);
  const navigate = useNavigate();
  const [state, setState] = useState({
    page: 1,
    ordering: "id",
    pagesize: 10,
    search: "",
    total: 0,
  });

  useEffect(() => {
    const getVendorOnboardingArchiveList = async () => {
      setLoading(true);

      try {
        let apiResponse = await getRequest(
          `vendor-assign-site-restore/`,
          state
        );

        if (apiResponse.data.results.success) {
          setArchiveVendorDocument(apiResponse.data.results.data);
          settotalCount(apiResponse.data.count);
        } else {
          ErrorNotificationMsg(t("error_in_archivelist"));
        }
        setLoading(false);
      } catch (error) {
        setLoading(false);
      }
    };

    getVendorOnboardingArchiveList();
  }, [state, t, reload]);

  const handleTableChange = async (pagination, filters, sorter, ordering) => {
    const orderBy = GetSortingEnumValue(sorter.columnKey, sorter.order);
    setState({
      ...state,
      page: pagination.current,
      pagesize: pagination.pageSize,
      ordering: orderBy,
    });
  };

  const GetSortingEnumValue = (sortField, sortOrder) => {
    let sortingEnumKey = "id";
    if (sortField === "address_master" && sortOrder === "ascend") {
      sortingEnumKey = "address_master";
    }
    if (sortField === "address_master" && sortOrder === "descend") {
      sortingEnumKey = "-address_master";
    }
    if (sortField === "material_type" && sortOrder === "ascend") {
      sortingEnumKey = "material_type";
    }
    if (sortField === "material_type" && sortOrder === "descend") {
      sortingEnumKey = "-material_type";
    }
    if (sortField === "category_tree" && sortOrder === "ascend") {
      sortingEnumKey = "category_tree";
    }
    if (sortField === "category_tree" && sortOrder === "descend") {
      sortingEnumKey = "-category_tree";
    }
    if (sortField === "gst_number" && sortOrder === "ascend") {
      sortingEnumKey = "gst_number";
    }
    if (sortField === "gst_number" && sortOrder === "descend") {
      sortingEnumKey = "-gst_number";
    }

    return sortingEnumKey;
  };
  const searchCallbackDelayed = (event) => {
    const { value } = event.target;
    debounceLoadData(value, onSearch);
  };
  const onSearch = (value) => {
    setState({
      ...state,
      search: value,
    });
  };

  const debounceLoadData = debounce((value, onSearch) => {
    onSearch(value);
  }, 1000);
  const rowSelection = {
    onChange: (selectedRowKeys) => {
      setSelectedRow(selectedRowKeys);
    },
  };

  const handleRestore = async (id = "") => {
    let ids = selectedRow;
    if (ids.length === 0) {
      ids.push(id);
    }
    try {
      let apiResponse = await postRequest("vendor-assign-site-restore/", {
        deleted: ids,
      });

      if (apiResponse.data.success) {
        SuccessNotificationMsg(t("assign_site_restore_successfully"));
        setSelectedRow([]);
        setReload(!reload);
        // navigate("/vendor");
      } else {
        ErrorNotificationMsg(t("error_in_restore_assign_site"));
      }
    } catch (error) {
      ErrorNotificationMsg(error);
    }
  };

  const columns = [
    {
      title: "Category",
      dataIndex: "category_tree_name",
      key: "category_tree",
      sorter: true,
    },
    {
      title: "Material Type",
      dataIndex: "material_type_name",
      key: "material_type",
      sorter: true,
    },
    {
      title: "Site",
      dataIndex: "address_master_name",
      key: "address_master",
      sorter: true,
    },
    {
      title: "GST Number",
      dataIndex: "gst_number",
      key: "gst_number",
      sorter: true,
    },

    {
      title: "Action",
      key: "operation",
      fixed: "right",
      width: 100,
      render: (text, record) => (
        <Space>
          <Popconfirm
            className="action"
            title={t("pop_restore_title")}
            okText={t("pop_ok")}
            cancelText={t("pop_cancel")}
            onConfirm={() => handleRestore(record.id)}
          >
            <ArchiveRestore
              className="ArchiverestorImg"
              style={{ cursor: "pointer" }}
            />{" "}
          </Popconfirm>
        </Space>
      ),
    },
  ];
  const colors = ["#094E8F"];
  return (
    <>
      <div className="ListingTopBar">
        <Breadcrumb className="Breadcrumb-Sec">
          <Breadcrumb.Item>
            <Link to="/dashboard">{t("home")}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>
            <Link to="/vendor">{t("vendorOnboarding")}</Link>
          </Breadcrumb.Item>
          <Breadcrumb.Item>{t("archive")} </Breadcrumb.Item>
        </Breadcrumb>
      </div>

      <section className="grid-sec mt-5">
        <div className="PR-body">
          <Row className="tblheader">
            <Col
              xs={24}
              sm={24}
              md={12}
              lg={12}
              xl={12}
              className="tbl-heading"
            >
              <Tooltip
                color={colors}
                placement="right"
                title={
                  <span style={{ color: "#fff" }}>
                   Archived entries retain historical data and can be reinstated if necessary.
                  </span>
                }
              >
                <h1>{t("archived_assign_site")}</h1>
              </Tooltip>
            </Col>

            <Col xs={24} sm={24} md={12} lg={12} xl={12} className="tbl-action">
              <div className="searchwrp">
                <Space direction="vertical">
                  <Search
                    prefix={
                      <img
                        src={SearchIcon}
                        alt="SearchIcon"
                        className="SearchIcon"
                        width={22}
                      />
                    }
                    placeholder={t("pl_search_list")}
                    onChange={searchCallbackDelayed}
                    style={{
                      width: 250,
                    }}
                  />
                </Space>
              </div>
              {selectedRow.length > 0 && (
                <Popconfirm
                  className="action"
                  title={t("pop_restore_title")}
                  okText={t("pop_ok")}
                  cancelText={t("pop_cancel")}
                  placement="left"
                  onConfirm={() => handleRestore()}
                >
                  <ButtonField
                    className="BlueShadowBtn"
                    type="primary"
                    htmlType="button"
                    label="Restore"
                  />
                </Popconfirm>
              )}
            </Col>
          </Row>

          <Table
            rowSelection={rowSelection}
            columns={columns}
            rowKey={(record) => record.id}
            dataSource={archiveVendorDocument}
            loading={loading}
            pagination={{
              defaultCurrent: state.page,
              defaultPageSize: state.pagesize,
              total: totalCount,
              showSizeChanger: true,
              showTotal: (total) => `Total ${total} items`,
              locale: {
                items_per_page: 'Items / Page', // Text for the size changer
              },
            }}
            onChange={handleTableChange}
          />
          <div className="FormFooter Container">
            <ButtonField
              className="CancelGradiantBtn"
              type="primary"
              htmlType="button"
              label={t("previous")}
              onClick={() =>
                navigate(
                  `/vendor`
                )
              }
            //onClick={() => setCurrentIndex(0)}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default ArchiveAssignSite;
